var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAirdropIllustrationBig1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "296px",
    height: "222px",
    viewBox: "0 0 296 222",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "airdrop_illustration_big_1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M6.68,25.83 C9.25,23.51 14.14,22.83 19.58,22.07 C26.64,21.07 35.23,21.84 39.21,14.75 C40.97,11.63 38.09,9.75 36.63,7.11 C34.97,4.11 34.11,3.65 33.05,0 C27.45,9.57 20.81,10.3 15.22,12 C10.27,13.48 5.38,14.56 0,19.1 L6.66,25.84 L6.68,25.83 Z",
    id: "path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.9014164,57.24 C27.9014164,51.88 22.4514164,45.54 16.3914164,38.5 C8.52141645,29.35 -3.88858355,20.25 1.18141645,8.29 C3.42141645,3.03 10.0014164,4.35 15.7114164,3.29 C22.2114164,2.12 24.0714164,2.58 30.7814164,-2.84217094e-14 C24.2214164,16.41 31.8914164,24.8 36.8414164,33 C41.2214164,40.24 46.0714164,47 46.5614164,57.89 L27.9714164,57.25 L27.9014164,57.24 Z",
    id: "path-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-5",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "0627\\u66F4\\u65B0--\\u7EA2\\u5305airdrop-\\u9886\\u7EA2\\u5305-\\u53EF\\u9886",
    transform: "translate(-572.000000, -293.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-27",
    transform: "translate(499.996798, 200.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "airdrop_illustration_big_1",
    transform: "translate(72.003202, 93.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\u692D\\u5706\\u5F62",
    fill: "#7269EF",
    fillRule: "nonzero",
    cx: 187.37,
    cy: 25.6987144,
    r: 24.61
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.47,44.9287144 C196.121224,44.9064249 203.691386,39.1069209 205.964916,30.7597513 C208.238446,22.4125817 204.654968,13.5751457 197.21,9.1687144 C203.849055,14.0210962 206.806576,22.4661246 204.645511,30.4003833 C202.484446,38.334642 195.65278,44.1133761 187.47,44.9287144 L187.47,44.9287144 Z",
    id: "\\u8DEF\\u5F84",
    fill: "#4E4EA0",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.45,45.9887144 C177,43.2987144 178.93,38.6587144 179.74,36.2387144 C180.236296,34.8177349 180.433754,33.3095649 180.32,31.8087144 C179.6,22.9987144 168.8,19.4187144 163.93,18.2387144 C163.82,18.5687144 163.73,18.8987144 163.64,19.2387144 C160.891113,29.3341564 164.826063,40.0640165 173.45,45.9887144 Z",
    id: "\\u8DEF\\u5F84",
    fill: "#5C5CC4",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.34,17.2087144 C155.14,4.4787144 143.9,-2.7912856 137.15,1.0087144 L136.95,1.1187144 L134.76,2.3887144 C135.138102,2.18269285 135.532819,2.00874973 135.94,1.8687144 C137.835715,1.28249406 139.864285,1.28249406 141.76,1.8687144 C146.98,3.2787144 152.9,8.0787144 157.66,15.0487144 L162.34,17.2087144 Z",
    id: "\\u8DEF\\u5F84",
    fill: "#4E4EA0",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.11,49.2687144 L160.11,49.2687144 L161.28,48.6187144 C161.5,48.4587144 161.72,48.2987144 161.93,48.1187144 C162.425682,47.6891683 162.868766,47.2024475 163.25,46.6687144 C167.25,41.1687144 166.07,29.7687144 159.95,18.8387144 C154.95,9.8387144 147.83,3.5187144 141.71,1.8387144 C139.814285,1.25249406 137.785715,1.25249406 135.89,1.8387144 C135.482819,1.97874973 135.088102,2.15269285 134.71,2.3587144 L134.52,2.4687144 C127.87,6.3587144 128.24,19.7687144 135.39,32.5387144 C142.4,45.0487144 153.28,52.3387144 160.11,49.2687144 Z",
    id: "\\u8DEF\\u5F84",
    fill: "#5C5CC4",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.82,44.6887144 C153.45,45.0787144 146.05,39.9687144 140.82,31.7387144 C134.51,21.8887144 133.62,11.2587144 138.82,7.9087144 L138.97,7.8187144 C139.265478,7.63762069 139.576749,7.48365855 139.9,7.3587144 C140.09131,7.27718128 140.288546,7.21032166 140.49,7.1587144 C139.803775,7.20231456 139.128767,7.35419142 138.49,7.6087144 C138.164887,7.72938191 137.853209,7.88354503 137.56,8.0687144 L137.41,8.1587144 C132.24,11.5087144 133.14,22.1587144 139.41,31.9887144 C145.1,40.9887144 153.39,46.2487144 158.82,44.6887144 Z",
    id: "\\u8DEF\\u5F84",
    fill: "#40407F",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.3,48.6087144 L162.87,47.7287144 L163.2,47.5487144 C169.98,43.7587144 169.65,30.2587144 162.45,17.4087144 C162.45,17.3387144 162.38,17.2687144 162.34,17.2087144 L157.63,15.0387144 C158.45,16.2387144 159.23,17.5087144 159.97,18.8287144 C166.09,29.7587144 167.24,41.1587144 163.27,46.6587144 C162.888766,47.1924475 162.445682,47.6791683 161.95,48.1087144 C161.76,48.2887144 161.52,48.4987144 161.3,48.6087144 Z",
    id: "\\u8DEF\\u5F84",
    fill: "#40407F",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "\\u692D\\u5706\\u5F62",
    fill: "#7269EF",
    fillRule: "nonzero",
    cx: 220.04,
    cy: 94.6287144,
    r: 24.61
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.14,113.858714 C228.791224,113.836425 236.361386,108.036921 238.634916,99.6897513 C240.908446,91.3425817 237.324968,82.5051457 229.88,78.0987144 C236.519055,82.9510962 239.476576,91.3961246 237.315511,99.3303833 C235.154446,107.264642 228.32278,113.043376 220.14,113.858714 L220.14,113.858714 Z",
    id: "\\u8DEF\\u5F84",
    fill: "#4E4EA0",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.47,70.8687144 C216.680818,68.2037346 206.259238,71.8165491 200.22,79.9687144 C205.76,82.0287144 223.94,87.4987144 226.47,70.8687144 Z",
    id: "\\u8DEF\\u5F84",
    fill: "#5C5CC4",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.12,76.1587144 C196.46,83.4787144 183.12,84.0187144 179.19,77.3387144 L179.08,77.1487144 L177.81,74.9187144 C178.027883,75.2930534 178.282471,75.6447858 178.57,75.9687144 C179.896504,77.4494415 181.639239,78.4950823 183.57,78.9687144 C188.78,80.3987144 196.31,79.2687144 203.95,75.6687144 L209.12,76.1587144 Z",
    id: "\\u8DEF\\u5F84",
    fill: "#4E4EA0",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.47,47.3987144 L223.47,47.3987144 L224.14,48.5587144 C224.257862,48.8058759 224.361367,49.0596308 224.45,49.3187144 C224.660703,49.9401246 224.795023,50.5848611 224.85,51.2387144 C225.49,57.9887144 218.71,67.2387144 207.85,73.5487144 C198.93,78.7587144 189.64,80.5987144 183.53,78.9187144 C181.599239,78.4450823 179.856504,77.3994415 178.53,75.9187144 C178.242471,75.5947858 177.987883,75.2430534 177.77,74.8687144 L177.66,74.6787144 C173.9,67.9487144 181.03,56.5887144 193.66,49.2087144 C206.06,42.0487144 219.13,41.2887144 223.47,47.3987144 Z",
    id: "\\u8DEF\\u5F84",
    fill: "#5C5CC4",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.03,50.6887144 C215.59,47.6287144 206.63,48.2787144 197.91,52.6887144 C187.48,57.9787144 181.32,66.6887144 184.07,72.1887144 L184.15,72.3487144 C184.314063,72.6549023 184.504801,72.9460294 184.72,73.2187144 C184.843076,73.3836414 184.980259,73.5375544 185.13,73.6787144 C184.549383,73.2916419 184.033103,72.8158546 183.6,72.2687144 C183.391625,71.9911778 183.201236,71.7005832 183.03,71.3987144 L182.95,71.2387144 C180.2,65.7287144 186.36,57.0287144 196.8,51.7387144 C206.33,46.9187144 216.15,46.5887144 220.03,50.6887144 Z",
    id: "\\u8DEF\\u5F84",
    fill: "#40407F",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.15,48.5687144 L225.06,50.1187144 L225.25,50.4387144 C229.17,57.1487144 222.04,68.6187144 209.32,76.0387144 L209.12,76.1587144 L203.96,75.6287144 C205.293333,75.0087144 206.606667,74.3187144 207.9,73.5587144 C218.72,67.2387144 225.5,57.9987144 224.9,51.2487144 C224.845023,50.5948611 224.710703,49.9501246 224.5,49.3287144 C224.398333,49.068739 224.281464,48.8149676 224.15,48.5687144 L224.15,48.5687144 Z",
    id: "\\u8DEF\\u5F84",
    fill: "#40407F",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.76,182.018714 C229.37,182.018714 295.52,190.768714 295.52,201.558714 C295.52,212.348714 229.37,221.108714 147.76,221.108714 C66.15,221.108714 0,212.358714 0,201.558714 C0,190.758714 66.15,182.018714 147.76,182.018714",
    id: "\\u8DEF\\u5F84",
    fill: "#444487"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#ACACFC",
    fillRule: "nonzero",
    x: 165.15,
    y: 105.688714,
    width: 99.21,
    height: 91.81
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#C7C7FF",
    fillRule: "nonzero",
    x: 129.93,
    y: 105.688714,
    width: 92.45,
    height: 91.81
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.57,68.9387144 C145.45,67.0787144 137.9,67.3487144 117.43,86.3187144 L120.34,89.5287144 L144.47,82.3087144 L149.47,74.7887144 L151.57,68.9387144 Z",
    id: "\\u8DEF\\u5F84",
    fill: "#5050AA"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(118.520000, 68.938714)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u8DEF\\u5F84"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#8282F4",
    fillRule: "nonzero",
    mask: "url(#mask-2)",
    x: 0,
    y: 0,
    width: 40.97,
    height: 25.83
  })), /*#__PURE__*/React.createElement("path", {
    d: "M50.36,61.9387144 C56.52,57.3087144 65.23,78.6687144 78.36,80.6887144 L75.79,82.9487144 C75.79,82.9487144 58.87,80.4587144 58.25,80.2387144 C57.63,80.0187144 53.25,76.7187144 53.25,76.7187144 L50.36,61.9387144 Z",
    id: "\\u8DEF\\u5F84",
    fill: "#5050AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.76,77.1387144 L50.33,61.9387144 C53.09,72.2587144 71.33,82.1687144 76.7,82.3487144 L67.3,88.5287144 C61.65,88.3387144 47.05,84.4287144 43.76,77.1387144",
    id: "\\u8DEF\\u5F84",
    fill: "#7269EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.83,37.4987144 C99.1,35.3887144 111.5,71.8687144 92.68,84.2287144 L99.68,85.5687144 C99.68,85.5687144 124.01,69.8387144 124.74,69.0887144 C125.47,68.3387144 128.47,60.4987144 128.47,60.4987144 L114.83,37.4987144 Z",
    id: "\\u8DEF\\u5F84",
    fill: "#5050AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.36,54.2387144 L114.83,37.4987144 C123.18,54.0687144 105.91,81.2487144 97.43,85.3787144 L120.35,87.3187144 C129.28,82.9787144 148.09,66.9187144 144.35,54.2387144",
    id: "\\u8DEF\\u5F84",
    fill: "#7269EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.49,33.7587144 C90.25,38.8687144 99.79,47.8387144 99.15,91.1187144 L90.63,91.1187144 L69.38,55.8387144 L73.76,42.2687144 L79.49,33.7587144 Z",
    id: "\\u8DEF\\u5F84",
    fill: "#5050AA"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Clipped",
    transform: "translate(48.708584, 33.728714)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-4",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u8DEF\\u5F84"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#8282F4",
    fillRule: "nonzero",
    mask: "url(#mask-4)",
    x: -3.88858355,
    y: 0.03,
    width: 50.45,
    height: 57.85
  })), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#ACACFC",
    fillRule: "nonzero",
    x: 65.07,
    y: 86.0887144,
    width: 100.25,
    height: 112.55
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#ACACFC",
    fillRule: "nonzero",
    x: 61.27,
    y: 83.5687144,
    width: 107.86,
    height: 22.12
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#C7C7FF",
    fillRule: "nonzero",
    x: 29.49,
    y: 86.0887144,
    width: 93.42,
    height: 112.55
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#C7C7FF",
    fillRule: "nonzero",
    x: 25.95,
    y: 83.5687144,
    width: 100.5,
    height: 22.12
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#ACACFC",
    fillRule: "nonzero",
    x: 29.49,
    y: 105.688714,
    width: 93.42,
    height: 3.71
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#7269EF",
    fillRule: "nonzero",
    x: 122.91,
    y: 105.688714,
    width: 42.41,
    height: 3.71
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#5050AA",
    fillRule: "nonzero",
    x: 163.5,
    y: 145.428714,
    width: 64.32,
    height: 64.67
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "\\u8DEF\\u5F84",
    fill: "#7269EF",
    points: "140.67 145.428714 200.61 145.428714 200.61 210.098714 140.67 210.098714"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.04,148.838714 C189.6,149.478714 209.39,147.548714 220.04,128.758714 L209.65,119.348714 C208.53,126.578714 206.77,144.788714 186.3,146.928714 L187.04,148.838714 Z",
    id: "\\u8DEF\\u5F84",
    fill: "#5050AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.52,147.878714 C187.89,136.938714 193.33,123.038714 212.14,116.588714 C215.142241,120.397783 217.793083,124.471111 220.06,128.758714 C213.06,127.208714 195.53,130.398714 187.06,148.838714 L185.52,147.878714 Z",
    id: "\\u8DEF\\u5F84",
    fill: "#7269EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.66,144.768714 L197.38,144.048714 C201.71,145.138714 214.76,142.858714 221.48,132.968714 L225.48,140.488714 C220.72,144.958714 213.87,149.488714 197.67,144.768714",
    id: "\\u8DEF\\u5F84",
    fill: "#5050AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.53,144.248714 L197.66,144.768714 C209.39,140.508714 213.83,138.648714 225.56,140.538714 L221.76,132.198714 C212.29,132.648714 208.64,135.378714 196.51,144.248714",
    id: "\\u8DEF\\u5F84",
    fill: "#7269EF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.18,126.958714 C156.64,133.628714 157.88,139.168714 162.98,141.958714 C170.98,146.408714 180.98,148.578714 188.09,149.218714 L188.57,148.218714 C184.94,147.218714 171.09,140.508714 169.24,137.218714 C166.779705,133.021809 166.507577,127.892377 168.51,123.458714 L156.18,126.958714 Z",
    id: "\\u8DEF\\u5F84",
    fill: "#5050AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.76,149.018714 C189.59,137.098714 179.05,121.308714 164.22,116.418714 L156.16,126.958714 C164.16,127.718714 186.04,136.308714 188.07,149.268714 L188.76,149.018714 Z",
    id: "\\u8DEF\\u5F84",
    fill: "#7269EF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#5050AA",
    fillRule: "nonzero",
    x: 161.06,
    y: 143.978714,
    width: 69.2,
    height: 12.71
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.34,144.768714 L173.62,144.048714 C169.29,145.138714 156.24,142.858714 149.52,132.968714 L145.52,140.488714 C150.28,144.958714 157.13,149.488714 173.33,144.768714",
    id: "\\u8DEF\\u5F84",
    fill: "#5050AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.47,144.248714 L173.34,144.768714 C161.61,140.508714 157.17,138.648714 145.43,140.538714 L149.22,132.198714 C158.69,132.648714 162.34,135.378714 174.47,144.248714",
    id: "\\u8DEF\\u5F84",
    fill: "#7269EF"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#7269EF",
    fillRule: "nonzero",
    x: 138.4,
    y: 143.978714,
    width: 64.48,
    height: 12.71
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#40407F",
    fillRule: "nonzero",
    x: 140.68,
    y: 156.688714,
    width: 59.93,
    height: 2.13
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#40407F",
    fillRule: "nonzero",
    x: 200.61,
    y: 156.688714,
    width: 27.21,
    height: 2.13
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    fill: "#40407F",
    fillRule: "nonzero",
    opacity: 0.26,
    x: 166.17,
    y: 156.688714,
    width: 8.95,
    height: 2.13
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.3,143.978714 C179.63,145.238714 168.45,159.448714 168.07,173.328714 C166.26,172.218714 156.7,164.478714 155.58,163.808714 C158.58,156.908714 171.17,144.808714 184.75,143.978714 L187.3,143.978714 Z",
    id: "\\u8DEF\\u5F84",
    fill: "#40407F",
    opacity: 0.26
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.3,143.978714 C179.35,145.238714 164.92,159.448714 161.37,173.328714 C159.81,172.218714 152.02,164.478714 151.05,163.808714 C155.61,156.908714 170.98,144.808714 184.75,143.978714 L187.3,143.978714 Z",
    id: "\\u8DEF\\u5F84",
    fill: "#5050AA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.55,143.978714 C180.22,143.588714 169.29,147.618714 163.55,157.628714 C160.87,157.158714 156.09,156.228714 153.81,155.628714 C164,143.128714 177.01,141.178714 185.6,143.988714",
    id: "\\u8DEF\\u5F84",
    fill: "#635BDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.53,137.998714 C60.9625184,138.105002 57.1700081,134.495856 57.05,129.928714 C56.980714,129.149038 57.3508104,128.395534 58.0102085,127.973763 C58.6696065,127.551992 59.5088547,127.531963 60.1876228,127.921796 C60.866391,128.31163 61.2720122,129.04662 61.24,129.828714 C61.3888145,132.015301 63.2347334,133.695964 65.4256544,133.639649 C67.6165754,133.583335 69.3737149,131.810059 69.41,129.618714 C69.4552744,128.512612 70.3514241,127.63161 71.458138,127.605196 C72.5648519,127.578783 73.50201,128.416031 73.6,129.518714 C73.7062877,134.086196 70.0971417,137.878706 65.53,137.998714 Z",
    id: "\\u8DEF\\u5F84",
    fill: "#ACACFC",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M84.63,137.498714 C80.0603727,137.610561 76.2645625,133.998274 76.15,129.428714 C76.080714,128.649038 76.4508104,127.895534 77.1102085,127.473763 C77.7696065,127.051992 78.6088547,127.031963 79.2876228,127.421796 C79.966391,127.81163 80.3720122,128.54662 80.34,129.328714 C80.4888145,131.515301 82.3347334,133.195964 84.5256544,133.139649 C86.7165754,133.083335 88.4737149,131.310059 88.51,129.118714 C88.5552744,128.012612 89.4514241,127.13161 90.558138,127.105196 C91.6648519,127.078783 92.60201,127.916031 92.7,129.018714 C92.8062877,133.586196 89.1971417,137.378706 84.63,137.498714 L84.63,137.498714 Z",
    id: "\\u8DEF\\u5F84",
    fill: "#ACACFC",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.76,132.278714 C50.6221966,132.24801 51.4154493,132.747759 51.76,133.538714 C56.25,143.938714 65.56,150.538714 75.47,150.258714 C85.38,149.978714 93.99,143.368714 98.12,132.918714 C98.5876062,131.908861 99.7618138,131.439138 100.7969,131.847864 C101.831986,132.256591 102.368492,133.401826 102.02,134.458714 C97.26,146.458714 87.13,154.158714 75.57,154.458714 C64.01,154.758714 53.09,147.188714 47.91,135.218714 C47.4498587,134.15555 47.9375826,132.920579 49,132.458714 C49.2390424,132.349352 49.4972992,132.288186 49.76,132.278714 Z",
    id: "\\u8DEF\\u5F84",
    fill: "#ACACFC",
    fillRule: "nonzero"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAirdropIllustrationBig1);
export default __webpack_public_path__ + "static/media/airdrop_illustration_big_1.ac09bc76fd91dc0b3862591cafad9079.svg";
export { ForwardRef as ReactComponent };